/**
 * OnboardingScreen — First-time welcome after license activation.
 *
 * UI-INV-005: Leaf component, props only.
 * NEW-UX-P1-002: Shown exactly once, after payment or token unlock.
 *
 * Sight   : sparse — title, three orientation lines, single CTA
 * Silence : no feature tour, no setup wizard — the practice teaches itself
 */
import styles from "./OnboardingScreen.module.css";

type Props = {
  onBegin: () => void;
};

export function OnboardingScreen({ onBegin }: Props) {
  return (
    <div className={styles.onboarding}>
      <div className={styles.eyebrow}>Welcome</div>

      <div className={styles.title}>Retreat Conductor</div>

      <div className={styles.lines}>
        <div className={styles.line} style={{ animationDelay: "0.1s" }}>Find a practice in the library.</div>
        <div className={styles.line} style={{ animationDelay: "0.26s" }}>Set a morning, or begin now.</div>
        <div className={styles.line} style={{ animationDelay: "0.42s" }}>
          Bells and silence hold each session.
        </div>
      </div>

      <div className={styles.note}>
        Everything works offline. No account needed once you're in.
      </div>

      <button className={styles.cta} type="button" onClick={onBegin} autoFocus>
        Begin
      </button>
    </div>
  );
}
